// Simple initials avatar — no external images needed for the demo. The
// background colour is derived from the user id hash so the same driver
// always gets the same colour across the app.
export function DriverAvatar({
  name,
  id,
  size = 32,
}: {
  name: string;
  id: string;
  size?: number;
}) {
  const initials = name
    .split(" ")
    .map((p) => p[0])
    .filter(Boolean)
    .slice(0, 2)
    .join("")
    .toUpperCase();
  // Stable colour from id: hash → hue. Use the same golden-ratio palette
  // as the vehicle markers so when the supervisor clicks a driver and
  // lands on the map, the avatar colour matches the marker colour.
  let h = 0;
  for (let i = 0; i < id.length; i++) h = (h * 31 + id.charCodeAt(i)) | 0;
  const hue = Math.abs(h) % 360;
  return (
    <div
      className="inline-flex items-center justify-center rounded-full font-semibold text-white"
      style={{
        width: size,
        height: size,
        fontSize: size * 0.4,
        background: `hsl(${hue}, 55%, 45%)`,
      }}
      title={name}
    >
      {initials || "?"}
    </div>
  );
}
